import { V2Relationships } from "src/pages/reports/fsci/v2/types";

export const meta: Record<V2Relationships, Opportunity> = {
    caringEnvironment: {
        title: "Caring Environment",
        prologue: "Teachers were kind, students felt included in class, and students were protected from bullying.",
    },
    christlikeTeachers: {
        title: "Christlike Teachers",
        prologue:
            "Teachers show Christlike love, kindness, and care to students. Families feel students are cared about individually, including their spiritual development.",
    },
    communityEngagement: {
        title: "Community Engagement",
        prologue:
            "The school engages with the surrounding community and local churches, and regularly taps into community resources including networking and resource-sharing with other schools.",
    },
    familyRelationships: {
        title: "Family Relationships",
        prologue:
            "Teachers “get to know” families, and frequent and systemic communication facilitates positive relationships.",
    },
    insularCulture: {
        title: "Insular Culture",
        prologue:
            "The school shields students from the world’s brokenness, the school is independent from the surrounding community, and/or the student body lacks diversity.",
        extra: "* The higher the score on this construct, the more respondents disagreed with the construct’s items. Thus, in general, a higher score would mean that fewer respondents viewed the school as shielding students, being independent from the community, and/or the student body lacks diversity.",
    },
    leadershipInterdependence: {
        title: "Leadership Interdependence",
        prologue:
            "Board members have diverse backgrounds, and are transparent about and rely on others to offset their weaknesses.",
    },
    mentoringStudents: {
        title: "Mentoring Students",
        prologue:
            "Staff point out talent in each student, help students see how they fit in God’s bigger plan, and are aware of students’ struggles at school or home.",
    },
    prosocialOrientation: {
        title: "Prosocial Orientation",
        prologue:
            "Students not only enjoy helping others, but also are known by others (e.g., peers) for showing love and care.",
    },
    supportiveLeadership: {
        title: "Supportive Leadership",
        prologue:
            "Principals are trusted, teachers feel that leaders “have our backs,” and leaders empower teachers and staff to make decisions.",
    },
};
